/*
* SundAir2019Plugin.js
*
* Description: This is our plugin object. It can be exported to be used anywhere.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2"
* Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore);

import moment from 'moment';

import {
    CONF_CLOSING_DAY_OF_MONTH,
} from '../config';


const SundAir2021Plugin = {

    install(Vue) { // options

        Vue.loader = '';


        /***********************************************************************
        * Global: make_basic_auth()
        *
        * Desc: Build 'Authorization' Key for API Calls.
        * Note: At 'Login' .. params are passed.
        *
        */
        Vue.prototype.$make_basic_auth = function (params) {

            var Base64 = {},
                token,
                hash,
                user = params.username ? params.username : 'booking_website',
                password = params.password ? params.password : 'D1sq3ccfwests!';


            Base64 = {
                // private property
                keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

                // public method for encoding
                encode: function (input) {
                    var output = '',
                        chr1,
                        chr2,
                        chr3,
                        enc1,
                        enc2,
                        enc3,
                        enc4,
                        i = 0;

                    input = Base64.utf8_encode(input);

                    while (i < input.length) {
                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);

                        enc1 = chr1 >> 2;
                        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                        enc4 = chr3 & 63;

                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }

                        output = output + this.keyStr.charAt(enc1) + this.keyStr.charAt(enc2) + this.keyStr.charAt(enc3) + this.keyStr.charAt(enc4);
                    }

                    return output;
                },
                // private method for UTF-8 encoding
                utf8_encode: function (string) {
                    var utftext = '',
                        n,
                        c;

                    string = string.replace(/\r\n/g, '\n');

                    for (n = 0; n < string.length; n++) {
                        c = string.charCodeAt(n);

                        if (c < 128) {
                            utftext += String.fromCharCode(c);
                        } else if (c > 127 && c < 2048) {
                            utftext += String.fromCharCode((c >> 6) | 192);
                            utftext += String.fromCharCode((c & 63) | 128);
                        } else {
                            utftext += String.fromCharCode((c >> 12) | 224);
                            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                            utftext += String.fromCharCode((c & 63) | 128);
                        }
                    }

                    return utftext;
                }
            };

            token = user + ':' + password;
            hash = Base64.encode(token);


            return 'Basic ' + hash;

        }; // eo function make_basic_auth()


        /***********************************************************************
        * Global: header_language()
        *
        * Desc: Right Header Language to send.
        * Note:
        *
        */
        Vue.prototype.$header_language = function () {

            var lang = 'DE',
                localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')); // catch


            // Language in localStrage?
            if (localStorageLanguage !== null) {
                lang = localStorageLanguage.value.toUpperCase();
            }

            return lang;

        }; // eo function header_language()


        /***********************************************************************
        * Global: lookUpCurrentBase()
        *
        * Desc: Returns the current base the resource in based.
        * Note: If no Base History Entry found, return null.
        *
        * @param {Object[]} m (Base History List)
        * @returns {Object | null} (BaseHistoryEntry)
        */
        Vue.prototype.$lookUpCurrentBase = function (baseHistory) {

            let baseHistory_Filtered = [],
                baseStationEntryToReturn = null;


            //filter out every base in the future
            baseHistory_Filtered = baseHistory.filter((b) => dayjs(b.sinceDate).startOf('day').isBefore(dayjs()));

            //sort by date
            baseHistory_Filtered.sort((a, b) => a.sinceDate < b.sinceDate ? 1 : -1);

            //take the first one as shown base
            if (baseHistory_Filtered.length > 0) {
                baseStationEntryToReturn = baseHistory_Filtered[0];
            }


            return baseStationEntryToReturn;

        }; // eo function lookUpCurrentBase()


        /***********************************************************************
        * Global: isEmpty()
        *
        * Desc:
        * Note: Checks if given Value is empty
        *
        * @param {Object[]} objectToCheck (Object to check)
        *
        */
        Vue.prototype.$isEmpty = function (objectToCheck) {

            let isEmpty = false;


            if (objectToCheck === '') {
                isEmpty = true;
            }
            if (objectToCheck === null) {
                isEmpty = true;
            }
            if (objectToCheck === undefined) {
                isEmpty = true;
            }


            return isEmpty;

        }; // eo function isEmpty()


        /***********************************************************************
        * Global: isActionAllowed()
        *
        * Desc: Check for: 'Is Action Allowed?'.
        * Note:
        *
        * @param {Object} objectToCheck ( {datesToCheck: '2019-12-24', isAdmin: true } )
        *
        */
        Vue.prototype.$isActionAllowed = function (objectToCheck) {

            // Admin is always allowed to perform actions.
            if (objectToCheck.isAdmin) {
                return true;
            }

            let closingDayOfActualMonth = CONF_CLOSING_DAY_OF_MONTH[dayjs().month()],
                todayIsBeforeClosingDayOfMonth = dayjs().startOf('day').isBefore(dayjs().set('date', closingDayOfActualMonth).startOf('day'));

            // Iterate over dates to check.
            for (let dateObject of objectToCheck.datesToCheck) {
                let date = dateObject;

                // If the date is in the future, action is allowed.
                if (dayjs(date).startOf('day').isAfter(dayjs())) {
                    continue;
                }

                // Check for date in current and previous month.
                let isPreviousMonth = dayjs(date).startOf('month').isSame(dayjs().subtract(1, 'month').startOf('month'));
                let isOlderMonth = dayjs(date).startOf('month').isSameOrBefore(dayjs().subtract(2, 'month').startOf('month'));

                if (todayIsBeforeClosingDayOfMonth) {
                    // If today is before closing date, only action on date older than previous month is not allowed.
                    if (isOlderMonth) {
                        return false;
                    }
                } else {
                    // If today is after closing date, action on date in previous month or older is not allowed.
                    if (isPreviousMonth || isOlderMonth) {
                        return false;
                    }
                }
            }

            // If none of the dates invalidated the action, it is allowed.
            return true;

        }; // eo function isActionAllowed()


        /***********************************************************************
        * Global: 'getFlightsCls'
        *
        * Desc: Retrurn Flighst 'cls'.
        * Note: Checks for
        *
        * @param {Array} crew
        * @return {String} (note, nameEvent)
        */
        Vue.prototype.$getFlightsCls = function (crew) {

            let cls = '',
                abort = false,
                t = null;


            for (var i = 0; i < crew.length; i++) {
                for (var z = 0; z < crew[i].roles.length; z++) {
                    t = crew[i].roles[z];
                    if (t === 'TRAINEE' || t === 'CHECKER' || t === 'INSTRUCTOR') {
                        cls = 'break_FLIGHT';
                        abort = true;
                        break;
                    }
                }
                if (abort) {
                    break;
                }
            }


            return cls;

        }; // eo function getFlightsCls()


        /***********************************************************************
        * Global: getEventColors()
        *
        * Desc: Return Event Colors/Cls.
        * Note: There is a new 'Crewplanning - Hook', Colors in/for Cp.
        *
        */
        Vue.prototype.$getEventColors = function (m) {

            const eventColors = [
                { flighttype: 'C', cls: 'flight_Commercial' },
                { flighttype: 'E', cls: 'flight_Technical' },
                { flighttype: 'T', cls: 'flight_Technical' },
                { flighttype: 'P', cls: 'flight_Positional' },
                { flighttype: 'F', cls: 'flight_Ferry' }
            ];


            return eventColors;

        }; // eo function getEventColors()


        /***********************************************************************
        * Global: 'getEventColors'
        *
        * Desc: Apps Event Colors.
        * Note:
        *
        * @return {Object} (note, nameEvent)
        */
        Vue.prototype.$getEventColors_Calendar = function () {

            const eventColors = [
                { duty: 'FLIGHT',       eventColor: '',             eventStyle: '',             cls: '',    breakName: '',              iconCls: '' }, // b-fa b-fa-plane-departure
                { duty: 'CICO',         eventColor: '',             eventStyle: '',             cls: '',    breakName: '',              iconCls: '' }, // b-fa b-fa-plane-departure
                { duty: 'PROCEEDING',   eventColor: 'green',        eventStyle: 'calendar',     cls: '',    breakName: 'PROCEEDING',    iconCls: '' }, // b-fa b-fa-car // colored
                { duty: 'HOTEL',        eventColor: 'violet',       eventStyle: 'calendar',     cls: '',    breakName: 'HOTEL',         iconCls: 'b-fa b-fa-hotel'  },  // minimal
                { duty: 'TRAINING',     eventColor: 'orange',       eventStyle: 'calendar',     cls: '',    breakName: 'TRAINING',      iconCls: 'b-fa b-fa-graduation-cap'   },        // minimal
                { duty: 'STANDBY',      eventColor: 'red',          eventStyle: 'calendar',     cls: '',    breakName: 'Standby',       iconCls: 'b-fa b-fa-bullhorn' },                // hollow
                { duty: 'AVAILABLE',    eventColor: 'pink',         eventStyle: 'calendar',     cls: '',    breakName: 'Available',     iconCls: 'b-fa b-fa-check-circle' },            // hollow
                { duty: 'RES',          eventColor: 'orange',       eventStyle: 'calendar',     cls: '',    breakName: 'RESERVE',       iconCls: 'b-fa b-fa-exchange-alt' },            // hollow
                { duty: 'VACATION',     eventColor: 'gray',         eventStyle: 'calendar',     cls: '',    breakName: 'Vacation',      iconCls: 'b-fa b-fa-umbrella-beach' },          // line
                { duty: 'OFFICE',       eventColor: 'blue',         eventStyle: 'calendar',     cls: '',    breakName: 'Office',        iconCls: 'b-fa b-fa-envelope' },                // minimal
                { duty: 'MEETING',      eventColor: 'indigo',       eventStyle: 'calendar',     cls: '',    breakName: 'Meeting',       iconCls: 'b-fa b-fa-user-friends' },            // minimal
                { duty: 'DAYOFF',       eventColor: 'yellow',       eventStyle: 'calendar',     cls: '',    breakName: 'Dayoff',        iconCls: 'b-fa b-fa-coffee' },                  // dashed
                { duty: 'FREEDAY',      eventColor: 'yellow',       eventStyle: 'calendar',     cls: '',    breakName: 'Freeday',       iconCls: 'b-fa b-fa-coffee' },                  // dashed
                { duty: 'UNABLEFLIGHT', eventColor: 'red',          eventStyle: 'calendar',     cls: '',    breakName: 'Unableflight',  iconCls: 'b-fa b-fa-ban'  },                    // hollow
                { duty: 'SICKNESS',     eventColor: 'gray',         eventStyle: 'calendar',     cls: '',    breakName: 'Sickness',      iconCls: 'b-fa b-fa-briefcase-medical' }        // hollow
            ];

            // red, pink, purple, violet, indigo, blue, cyan, teal, green, lime, yellow, orange, deep-orange, gray, gantt-green

            return eventColors;

        }; // eo function getEventColors()


        /***********************************************************************
        * Global: 'buildEventNote'
        *
        * Desc: Build 'Note' for Event Tooltips.
        * Note: Used in: 'Save modified Event', 'Build Scheduler Data'.
        *
        * @param {Object} record
        * @return {Object} (note, nameEvent)
        */
        Vue.prototype.$buildEventNote = function (record) {

            let note = '',
                nameEvent = '',
                sicknessInfo = '',
                vacationInfo = '';


            switch (record.name || record.type) {
                case 'DAYOFF':
                    note = record.requested !== null ? '<strong>Requested:</strong> ' + record.requested : '<strong>Requested:</strong> no info';
                    note += record.remainingDayOff !== null ? '<br /><strong>Remaining:</strong> ' + record.remainingDayOff : '<br /><strong>Remaining:</strong> no info';
                    note += record.activated !== null ? '<br /><strong>Activated:</strong> ' + record.activated : '<br /><strong>Activated:</strong> no info';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';

                    if (record.requested === true && record.remainingDayOff !== true) {
                        nameEvent = 'DAYOFF' + ' (req.)';
                    } else if (record.requested === true && record.remainingDayOff === true) {
                        nameEvent = 'DAYOFF' + ' (req. rem.)';
                    } else if (record.requested !== true && record.remainingDayOff === true) {
                        nameEvent = 'DAYOFF' + ' (rem.)';
                    } else {
                        nameEvent = 'DAYOFF';
                    }
                    break;
                case 'FREEDAY':
                    note = record.requested !== null ? '<strong>Requested:</strong> ' + record.requested : '<strong>Requested:</strong> no info';
                    note += record.remainingDayOff !== null ? '<br /><strong>Remaining:</strong> ' + record.remainingDayOff : '<br /><strong>Remaining:</strong> no info';
                    note += record.activated !== null ? '<br /><strong>Activated:</strong> ' + record.activated : '<br /><strong>Activated:</strong> no info';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';

                    if (record.requested === true && record.remainingDayOff !== true) {
                        nameEvent = 'FREEDAY' + ' (req.)';
                    } else if (record.requested === true && record.remainingDayOff === true) {
                        nameEvent = 'FREEDAY' + ' (req. rem.)';
                    } else if (record.requested !== true && record.remainingDayOff === true) {
                        nameEvent = 'FREEDAY' + ' (rem.)';
                    } else {
                        nameEvent = 'FREEDAY';
                    }
                    break;
                case 'STANDBY':
                    note = '<strong>(U) ' + Vue.prototype.$locToUtcTime(record.from) + ' - ' + Vue.prototype.$locToUtcTime(record.to) + '</strong>';
                    note += record.aptCode !== null ? '<br /><br /><strong>Airport:</strong> ' + record.aptCode : '<br /><br /><strong>Airport:</strong> no info';
                    note += record.activationDate !== null ? '<br /><strong>Activated:</strong> ' + Vue.prototype.$locToUtcTime(record.activationDate) + '' : '<br /><strong>Activated:</strong> no';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    nameEvent = '<div style="font-size: 10px;">SBY-' + record.aptCode + '<br />' + Vue.prototype.$locToUtcTime(record.from) + '-' + Vue.prototype.$locToUtcTime(record.to) + '</div>';
                    break;
                case 'RES':
                    note = '<strong>Reserve from-to:</strong>';
                    note += '<br /><strong>(U) ' + Vue.prototype.$locToUtcTime(record.from) + ' - ' + Vue.prototype.$locToUtcTime(record.to) + '</strong>';
                    note += '<br /><br /><strong>Sleep period from-to:</strong>';
                    note += '<br /><strong>(U) ' + Vue.prototype.$locToUtcTime(record.sleepFrom) + ' - ' + Vue.prototype.$locToUtcTime(record.sleepTo) + '</strong>';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    nameEvent = '<div style="font-size: 10px;">RES<br />' + Vue.prototype.$locToUtcTime(record.from) + '-' + Vue.prototype.$locToUtcTime(record.to) + '</div>';
                    break;
                case 'VACATION':
                    note += '<strong>Vacation from-to:</strong>';
                    note += '<br /><strong>' + moment.utc(record.from, moment.ISO_8601).format('YYYY-MM-DD') + ' - ' + moment.utc(record.to, moment.ISO_8601).format('YYYY-MM-DD') + '</strong>';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    vacationInfo += record.requestStatus === 'REQUESTED' ? 'REQ ' : '';
                    vacationInfo += record.requestStatus === 'MAINREQUEST' ? 'MREQ ' : '';
                    vacationInfo += record.requestStatus === 'SECONDARYREQUEST' ? 'SREQ' : '';
                    vacationInfo += record.requestStatus === 'REPLACEMENTREQUEST' ? 'RREQ' : '';
                    vacationInfo += record.requestStatus === 'APPROVED' ? 'APR' : '';
                    vacationInfo += record.requestStatus === 'REFUSED' ? 'REF' : '';

                    nameEvent = '<div style="font-size: 10px;">VACATION<br />' + vacationInfo + '</div>'; // #611
                    break;
                case 'OFFICE':
                    note = '<strong>(U) ' + Vue.prototype.$locToUtcTime(record.from) + ' - ' + Vue.prototype.$locToUtcTime(record.to) + '</strong>';
                    if (record.requested !== null) {
                        note += record.requested === true ? '<br /><br /><strong>Requested:</strong> YES' : '<br /><br /><strong>Requested:</strong> NO';
                    }
                    if (record.requested === null) {
                        note += '<br /><br /><strong>Requested:</strong> no info';
                    }
                    note += record.aptCode !== null ? '<br /><strong>Airport:</strong> ' + record.aptCode : '<br /><strong>Airport:</strong> no info';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';

                    if (record.requested === true) {
                        nameEvent = 'OFFICE' + ' (req.)';
                    } else {
                        nameEvent = 'OFFICE';
                    }
                    break;
                case 'UNABLEFLIGHT':
                    note += '<strong>Unable to fly from-to:</strong>';
                    note += '<br /><strong>' + moment.utc(record.from, moment.ISO_8601).format('YYYY-MM-DD') + ' - ' + moment.utc(record.to, moment.ISO_8601).format('YYYY-MM-DD') + '</strong>';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    nameEvent = record.dutyComment !== null ? '<div style="font-size: 10px;">UNABLEFLIGHT<br />' + record.dutyComment + '</div>' : '<div style="font-size: 10px;">UNABLEFLIGHT<br />';
                    break;
                case 'AVAILABLE':
                    note += '<strong>(U) ' + moment.utc(record.from, moment.ISO_8601).format('YYYY-MM-DD') + ' - ' + moment.utc(record.to, moment.ISO_8601).format('YYYY-MM-DD') + '</strong>';
                    note += record.aptCode !== null ? '<br /><br /><strong>Airport:</strong> ' + record.aptCode : '<br /><br /><strong>Airport:</strong> no info';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    nameEvent = '<div style="font-size: 10px;">AVAILABLE</div>';
                    break;
                case 'MEETING':
                    note += '<strong>(U) ' + Vue.prototype.$locToUtcTime(record.from) + ' - ' + Vue.prototype.$locToUtcTime(record.to) + '</strong>';
                    note += record.aptCode !== null ? '<br /><br /><strong>Airport:</strong> ' + record.aptCode : '<br /><br /><strong>Airport:</strong> no info';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    nameEvent = 'MEETING';
                    break;
                case 'SICKNESS':
                    note = '<strong>Sickness from-to:</strong>';
                    note += '<br /><strong>' + moment.utc(record.from, moment.ISO_8601).format('YYYY-MM-DD') + ' - ' + moment.utc(record.to, moment.ISO_8601).format('YYYY-MM-DD') + '</strong>';
                    note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                    sicknessInfo += record.certificate === true ? 'C ' : '';
                    sicknessInfo += record.fit === true ? 'F ' : '';
                    sicknessInfo += record.sickOnTour === true ? 'SOT ' : '';
                    sicknessInfo += record.sickChild === true ? 'SC ' : '';
                    nameEvent = '<div style="font-size: 10px;">SICKNESS<br />' + sicknessInfo + '</div>';
                    break;
                default:
                    if (record.type === 'TRAINING') {
                        note = '<strong>(U) ' + Vue.prototype.$locToUtcTime(record.nextCheckStartDate) + '-' + Vue.prototype.$locToUtcTime(record.nextCheckEndDate) + '</strong>';
                        note += '<br /><br /><strong>Code: </strong><br />' + record.code;
                        note += '<br /><strong>From-To:</strong><br />' + record.aptFromCode + '-' + record.aptToCode;
                        note += record.notes  !== null ? '<br /><br /><strong>Notes:</strong><br /> ' + record.notes : '<br /><br /><strong>Notes:</strong><br /> no info';
                        nameEvent = 'TRAINING';
                    }
                    if (record.type === 'HOTEL') {
                        note = '<strong>Checkin/Checkout:</strong>';
                        note += '<br /><strong>(U) ' + Vue.prototype.$locToUtcTDateTime(record.checkinDate) + ' - ' + Vue.prototype.$locToUtcTDateTime(record.checkoutDate) + '</strong>';
                        note += record.comment !== null ? '<br /><br /><strong>Info:</strong><br />' + record.comment : '<br /><br /><strong>Info:</strong> no info';
                        note += '<br /><br /><strong>Hotel:</strong><br />' + record.name;
                        note += '<br /><br /><strong>City:</strong> ' + record.cityName;
                        note += '<br /><strong>Phone:</strong> <a href="tel:' + record.telephone + '">' + record.telephone + '</a>';
                        nameEvent = 'HOTEL' + ' (' + record.status.toLowerCase() + ')';
                    }
                    if (record.type === 'PRO') {
                        note = '<strong>(U) ' + Vue.prototype.$locToUtcTime(record.proceedingStart) + '-' + Vue.prototype.$locToUtcTime(record.proceedingEnd) + '</strong>';
                        note += record.info !== null ? '<br /><br /><strong>Info:</strong><br />' + record.info : '<br /><br /><strong>Info:</strong> no info';
                        note += '<br /><br /><strong>From-To:</strong><br />' + record.proceedingFrom + '-' + record.proceedingTo;
                        note += record.codeAptFrom !== null ? '<br /><br /><strong>Apt-Apt:</strong> ' + record.codeAptFrom + '-' + record.codeAptTo : '<br /><br /><strong>Apt-Apt:</strong> no info';
                        note += '<br /><strong>Travel by:</strong> ' + record.typeOfProceeding;
                        nameEvent = record.codeAptFrom !== null ? '<strong>' + record.codeAptFrom + '<br />' + record.codeAptTo  + '</strong>' : '<strong>no airports</strong>';
                    }
                    if (record.type === 'FLIGHT') {
                        note = '<strong>(U) ' + Vue.prototype.$locToUtcTime(record.departureDateTimeLocal) + '-' + Vue.prototype.$locToUtcTime(record.destinationDateTimeLocal) + '</strong><br /><strong>' + record.departureAirportInfo.iataCode + '-' + record.destinationAirportInfo.iataCode + '</strong><br /><br /><strong>' + record.flightNo + ' - ' + record.aircraftType + '</strong>';
                        note += record.dutyComment !== null ? '<br /><br /><strong>Comment:</strong><br />' + record.dutyComment : '<br /><br /><strong>Comment:</strong> no info';
                        note += record.flightComment !== null ? '<br /><br /><strong>Comment (Flight):</strong><br />' + record.flightComment : '<br /><br /><strong>Comment (Flight):</strong> no info';
                        nameEvent = '<strong>' + record.departureAirportInfo.iataCode + ' ' + record.destinationAirportInfo.iataCode + '</strong>';
                    }
                    if (record.type === 'CI') {
                        note = 'Checkin:<br /><strong> (U) ' + Vue.prototype.$locToUtcTime(record.dutyInfo.dutyCheckin) + '</strong>';
                    }
                    if (record.type === 'CO') {
                        note = 'Checkout:<br /><strong> (U) ' + Vue.prototype.$locToUtcTime(record.dutyInfo.dutyCheckout) + '</strong>';
                    }
                    break;
            };


            return { note, nameEvent };

        }; // eo function buildEventNote()


        /*******************************************************************************
        * Filter:: 'dayjsUTCToLocal'
        *
        * Desc:
        * Note:
        *
        * @param {string} date (ISO Format - 2021-05-07T09:20:00+0300)
        * @return {string}
        */
        Vue.prototype.$dayjsUTCToLocal = function (date, format) {

            let formattedDate = null;


            if (format === undefined || format === null || format === '') {
                format = 'HH:mm';
            }

            if (date !== null && date !== '') {
                switch (format) {
                    case 'HH:mm':
                        formattedDate = date.substring(11, 16);
                        break;
                    default:
                        formattedDate = '';
                        break;
                }
            }


            return formattedDate;

        }; // eo function dayjsUTCToLocal()


        /***********************************************************************
        * Global: 'dayjsLocalToUTC'
        *
        * Desc:
        * Note:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        Vue.prototype.$dayjsLocalToUTC = function (date, format) {

            let formattedDate = null;


            if (format === undefined || format === null || format === '') {
                format = 'HH:mm';
            }

            if (date !== null && date !== '') {
                switch (format) {
                    case 'HH:mm':
                        formattedDate = dayjs(date).utc().format('HH:mm');
                        break;
                    case 'DD.MM.YYYY HH:mm':
                        formattedDate = dayjs(date).utc().format('DD.MM.YYYY HH:mm');
                        break;
                    case 'DD.MM.YYYY':
                        formattedDate = dayjs(date).utc().format('DD.MM.YYYY');
                        break;
                    case 'dddd, DD.MM.YYYY':
                        formattedDate = dayjs(date).utc().format('dddd, DD.MM.YYYY');
                        break;
                    case 'YYYY-MM-DD':
                        formattedDate = dayjs(date).utc().format('YYYY-MM-DD');
                        break;
                    default:
                        formattedDate = '';
                        break;
                }
            }


            return formattedDate;

        }; // eo function dayjsLocalToUTC()


        /***********************************************************************
        * Global: 'locToUtcTDateTime'
        *
        * Desc: Format Date/Time.
        * Note:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        Vue.prototype.$locToUtcTDateTime = function (date) {

            return moment.utc(date, moment.ISO_8601).format('YYYY-MM-DD, HH:mm');

        }; // eo function locToUtcTDateTime()


        /***********************************************************************
        * Global: 'locToUtcTime'
        *
        * Desc: Format Date/Time.
        * Note:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        Vue.prototype.$locToUtcTime = function (date) {

            return moment.utc(date, moment.ISO_8601).format('HH:mm');

        }; // eo function locToUtcTime()


        /***********************************************************************
        * Global: 'buildUTCTime'
        *
        * Desc: Build/Change Time to UTC.
        * Note: makefulldayfrom, makefulldayto ... to make it a Full Day
        *
        * @return {Object} (note, nameEvent)
        */
        Vue.prototype.$buildUTCTime = function (timeToChange, makefulldayfrom=false, makefulldayto=false) {

            let changedTime = '',
                yearDepartureTime = null,
                monthDepartureTime = null,
                dayDepartureTime = null,
                hoursDepartureTime = null,
                minutesDepartureTime = null;


            changedTime = moment.utc(timeToChange, moment.ISO_8601).toDate();

            yearDepartureTime = moment.utc(timeToChange, moment.ISO_8601).format('YYYY');
            monthDepartureTime = moment.utc(timeToChange, moment.ISO_8601).format('MM');
            dayDepartureTime = moment.utc(timeToChange, moment.ISO_8601).format('DD');
            hoursDepartureTime = moment.utc(timeToChange, moment.ISO_8601).format('HH');
            minutesDepartureTime = moment.utc(timeToChange, moment.ISO_8601).format('mm');

            changedTime.setYear(yearDepartureTime);
            changedTime.setMonth(monthDepartureTime - 1);
            changedTime.setDate(dayDepartureTime);
            changedTime.setHours(hoursDepartureTime);
            changedTime.setMinutes(minutesDepartureTime);

            // >>> special case ...23:59 ------------------
            if (makefulldayfrom === true) {
                changedTime.setHours(0);
                changedTime.setMinutes(0);
            }
            if (makefulldayto === true) {
                changedTime.setHours(23);
                changedTime.setMinutes(59);
            }


            return changedTime;

        }; // eo function buildUTCTime()


        /*******************************************************************************
        * Filter:: 'createATCCallSign'
        *
        * Desc: Create ATC Call Sign based on Flight No.
        * Note: Only possible if Flight No starts with SR.
        *
        * @param {string} flightNo (Format: /^[a-z]{1,3}\d{1,4}[a-z]{0,1}$/)
        * @return {string | undefined} ATC Call Sign
        * TODO: just for SR#### nr? what happens to X#### flightNrs?
        * TODO: what happens if there is a postfix letter? SR123X
        */
        Vue.prototype.$createATCCallSign = function (flightNo) {

            /*******************************************************************************
            * getLetterlistForRange
            *
            * Desc:
            */
            const getLetterlistForRange = (flightNo_Numbers) => {

                let flightNo_Range = flightNo_Numbers.substring(0, 2),
                    prefix = '',
                    letterlist = '';


                if(flightNo_Range[1] === "0" || flightNo_Range[1] === "1") {
                    prefix = "X";
                } else if(flightNo_Range[1] === "2" || flightNo_Range[1] === "3") {
                    prefix = "Y";
                } else if(flightNo_Range[1] === "4" || flightNo_Range[1] === "5") {
                    prefix = "A";
                } else if(flightNo_Range[1] === "6" || flightNo_Range[1] === "7") {
                    prefix = "B";
                } else if(flightNo_Range[1] === "8" || flightNo_Range[1] === "9") {
                    prefix = "C";
                }


                const letterlistObjects = [
                    {
                        numberRange: ["10"],
                        letterlist: "MPRTXACEHJMPRTXACEHPTAEKQWBGMXENWDMTCKSHSDPAKWGRCWJXKYMANBPMCSJAQGXNDEYRKDXQJCWBXSPKGCYTQAYXWTSRQPN"
                    },
                    {
                        numberRange: ["11", "20"],
                        letterlist: "PRTXACEHKKNQSWYBDGJRXCHNSYDJPBJRAHQYGPXNYJTEQBMXHCQDRESGTHWTKBRHYPEWMPHBTNGASMEMHDAWRNJEBMKJHGEDCBA"
                    },
                    {
                        numberRange: ["12", "21", "30"],
                        letterlist: "RTXACEHKNMPRTXACEHKTAEKQWBGMRENWDMTCKSBSDPAKWGRCNJXKYMANBPCCSJAQGXNDTYRKDXQJCWPXSPKGCYTQMYXWTSRQPNM"
                    },
                    {
                        numberRange: ["13", "22", "31", "40"],
                        letterlist: "TXACEHKNQNQSWYBDGJMXCHNSYDJPTJRAHQYGPXEYJTEQBMXHSQDRESGTHWJKBRHYPEWMCHBTNGASMEYHDAWRNJEBXKJHGEDCBAY"
                    },
                    {
                        numberRange: ["14", "23", "32", "41", "50"],
                        letterlist: "XACEHKNQSPRTXACEHKNAEKQWBGMRXNWDMTCKSBJDPAKWGRCNYXKYMANBPCQSJAQGXNDTKRKDXQJCWPHSPKGCYTQMHXWTSRQPNMK"
                    },
                    {
                        numberRange: ["15", "24", "33", "42", "51", "60"],
                        letterlist: "ACEHKNQSWQSWYBDGJMPCHNSYDJPTARAHQYGPXENJTEQBMXHSDDRESGTHWJXBRHYPEWMCSBTNGASMEYRDAWRNJEBXSJHGEDCBAYX"
                    },
                    {
                        numberRange: ["16", "25", "34", "43", "52", "61", "70"],
                        letterlist: "CEHKNQSWYRTXACEHKNQEKQWBGMRXCWDMTCKSBJRPAKWGRCNYJKYMANBPCQDJAQGXNDTKBKDXQJCWPHBPKGCYTQMHDWTSRQPNMKJ"
                    },
                    {
                        numberRange: ["17", "26", "35", "44", "53", "62", "71", "80"],
                        letterlist: "EHKNQSWYBSWYBDGJMPRHNSYDJPTAEAHQYGPXENWTEQBMXHSDPRESGTHWJXKRHYPEWMCSJTNGASMEYRKAWRNJEBXSPHGEDCBAYXW"
                    },
                    {
                        numberRange: ["18", "27", "36", "45", "54", "63", "72", "81", "90"],
                        letterlist: "HKNQSWYBDTXACEHKNQSKQWBGMRXCHDMTCKSBJRAAKWGRCNYJTYMANBPCQDRAQGXNDTKBRDXQJCWPHBTKGCYTQMHDATSRQPNMKJH"
                    },
                    {
                        numberRange: ["19", "28", "37", "46", "55", "64", "73", "82", "91"],
                        letterlist: "KNQSWYBDGWYBDGJMPRTNSYDJPTAEKHQYGPXENWDEQBMXHSDPAESGTHWJXKYHYPEWMCSJANGASMEYRKDWRNJEBXSPKGEDCBAYXWT"
                    },
                    {
                        numberRange: ["29", "38", "47", "56", "65", "74", "83", "92"],
                        letterlist: "NQSWYBDGJXACEHKNQSWQWBGMRXCHNMTCKSBJRAHKWGRCNYJTEMANBPCQDREQGXNDTKBRHXQJCWPHBTNGCYTQMHDAWSRQPNMKJHG"
                    },
                    {
                        numberRange: ["39", "48", "57", "66", "75", "84", "93"],
                        letterlist: "QSWYBDGJMYBDGJMPRTXSYDJPTAEKQQYGPXENWDMQBMXHSDPAKSGTHWJXKYMYPEWMCSJAQGASMEYRKDXRNJEBXSPKGEDCBAYXWTS"
                    },
                    {
                        numberRange: ["49", "58", "67", "76", "85", "94"],
                        letterlist: "SWYBDGJMPACEHKNQSWYWBGMRXCHNSTCKSBJRAHQWGRCNYJTEQANBPCQDRESGXNDTKBRHYQJCWPHBTNGCYTQMHDAWRRQPNMKJHGE"
                    },
                    {
                        numberRange: ["59", "68", "77", "86", "95"],
                        letterlist: "WYBDGJMPRBDGJMPRTXAYDJPTAEKQWYGPXENWDMTBMXHSDPAKWGTHWJXKYMAPEWMCSJAQGASMEYRKDXQNJEBXSPKGCDCBAYXWTSR"
                    },
                    {
                        numberRange: ["69", "78", "87", "96"],
                        letterlist: "YBDGJMPRTCEHKNQSWYBBGMRXCHNSYCKSBJRAHQYGRCNYJTEQBNBPCQDRESGXNDTKBRHYPJCWPHBTNGAYTQMHDAWRNQPNMKJHGED"
                    },
                    {
                        numberRange: ["79", "88", "97"],
                        letterlist: "BDGJMPRTXDGJMPRTXACDJPTAEKQWBGPXENWDMTCMXHSDPAKWGTHWJXKYMANEWMCSJAQGXSMEYRKDXQJJEBXSPKGCYCBAYXWTSRQ"
                    },
                    {
                        numberRange: ["89", "98"],
                        letterlist: "DGJMPRTXAEHKNQSWYBDGMRXCHNSYDKSBJRAHQYGRCNYJTEQBMBPCQDRESGTNDTKBRHYPECWPHBTNGASTQMHDAWRNJPNMKJHGEDC"
                    },
                    {
                        numberRange: ["99"],
                        letterlist: "GJMPRTXACGJMPRTXACEJPTAEKQWBGPXENWDMTCKXHSDPAKWGRHWJXKYMANBWMCSJAQGXNMEYRKDXQJCEBXSPKGCYTBAYXWTSRQP"
                    }
                ];


                letterlist = letterlistObjects.find(letterlistobject => letterlistobject.numberRange.includes(flightNo_Range)).letterlist;


                return prefix + letterlist;

            }; // eo function getLetterlistForRange()


            let ATCCallSign = undefined,
                flightNo_Prefix = '',
                flightNo_Numbers = '',
                splitted = [],
                letterlistForRange = '';
            const letters = "ABCDEGHJKMNPQRSTWXYYXWTSRQPNMKJHGEDCBA";


            if(/^SR\d{3,4}$/ig.test(flightNo) === false) {
                return ATCCallSign; // undefined
            }


            splitted = flightNo.match(/^SR|\d{3,4}$/ig);
            if(splitted.length < 2) {
                return ATCCallSign; // undefined
            }

            flightNo_Prefix = splitted[0]; // "SR"
            flightNo_Numbers = splitted[1];


            ATCCallSign = "SDR";
            ATCCallSign += flightNo_Numbers[0];
            ATCCallSign += flightNo_Numbers[2];
            ATCCallSign += letters[parseInt(flightNo_Numbers) % letters.length - 1];
            if(parseInt(flightNo_Numbers) >= 1 && parseInt(flightNo_Numbers) <= 599) {
                ATCCallSign += "L";
            } else if(parseInt(flightNo_Numbers) >= 600 && parseInt(flightNo_Numbers) <= 999) {
                ATCCallSign += "F";
            } else {
                letterlistForRange = getLetterlistForRange(flightNo_Numbers);
                ATCCallSign += letterlistForRange[parseInt(flightNo_Numbers.slice(-2))];
            }



            return ATCCallSign;

        }; // eo function createATCCallSign()


        /***********************************************************************
        * Global: 'build_MultipleDuties'
        *
        * Desc:
        * Note:
        * ToDo: CLEAN UP HERE!!!
        *
        * @return {Object} payload (Calls Objects to build Stores Records)
        */
        Vue.prototype.$build_MultipleDuties = function (payload) {

            const eventColors = Vue.prototype.$getEventColors_Calendar();
            let resourceId = null,
                tmpArrayFlights = [],
                tmpArrayCiCos = [],
                tmpArrayTrainings = [],
                tmpArrayProceedings = [],
                tmpArrayHotels = [],
                tmpArrayBreaks = [],
                recs = [],
                utcDepartureTime = null,
                utcArrivalTimeSleep = null,
                utcDepartureTimeSleep = null,
                utcDepartureTimeActivation = null,
                utcArrivalTime = null,
                year_departure_time = null,
                month_departure_time = null,
                day_departure_time = null,
                hours_departure_time = null,
                minutes_departure_time = null,
                year_arrival_time = null,
                month_arrival_time = null,
                day_arrival_time = null,
                hours_arrival_time = null,
                minutes_arrival_time = null,
                t = null,
                t2 = null, // ci
                t3 = null, // co
                datebefore = null, // ci
                resourceIdBefore = null,
                datebefore2 = null, // co
                resourceIdBefore2 = null,
                mycrew = '',
                tmp = '',
                roles = '',
                note = '',
                nameEvent = '',
                tooltiptData = '',
                style = null;


            // >>> -----------------------------------------------------------------// forEach - Results
            payload.forEach((item, i) => {

                resourceId = item.crewMemberInfo.id; // remember 'resourceId'


                // >>> 'flightInfos/cicos' -------------------- // OK, New: via ... buildUTCTime
                if (item.flightInfos && item.flightInfos.length) {
                    item.flightInfos.forEach(flight => {

                        // >>> Flight -----------------------------------
                        let getColors = eventColors.find(colors => colors.duty === 'FLIGHT');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';

                        // >>> Notes & More ----------------------------------------
                        flight.type = 'FLIGHT';
                        // flight.flightComment = 'Michael'; // tmp
                        tooltiptData = Vue.prototype.$buildEventNote(flight);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Crew ------------------------------------------------
                        mycrew = '';
                        roles = '';
                        tmp = '';
                        flight.crew.forEach((crew, i) => {
                            mycrew = mycrew + crew.contract3Code;

                            tmp = crew.onDuty ? ' <span style="color: red;">DU</span>' : ''; // onDuty
                            tmp += crew.takeoff === true || crew.landing === true ?  '(TL)' : '';
                            tmp += crew.manualStatus === 'C' ?  '(cd)' : '';
                            tmp += crew.manualStatus === 'E' ?  '(e)' : '';
                            mycrew = mycrew + tmp;

                            roles = '';
                            crew.roles.forEach((role, i) => { // Roles
                                roles = roles + ' ' + role.charAt(0);
                            });
                            mycrew = mycrew + roles;

                            mycrew = mycrew  + ',';
                        });
                        mycrew = mycrew.slice(0, -1);



                        // >>> Push ------------------------------------------------
                        t = {
                            originalId: flight.id, // Note: #67
                            resourceId: resourceId,
                            startDate: Vue.prototype.$buildUTCTime(flight.departureDateTimeLocal),
                            endDate: Vue.prototype.$buildUTCTime(flight.destinationDateTimeLocal),
                            name: 'FLIGHT', // for Tooltip Header
                            note: note,
                            nameEvent: nameEvent,
                            crew: mycrew,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: flight.dutyComment !== null ? 'border-right: 3px dotted #000;' : null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: Vue.prototype.$getFlightsCls(flight.crew), // getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: flight.dutyComment,
                            flightComment: flight.flightComment,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: null,
                        };
                        tmpArrayFlights.push(t);
                        // <<< Flight -----------------------------------





                        // >>> Checkin ----------------------------------
                        getColors = eventColors.find(colors => colors.duty === 'CICO');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';


                        // >>> Notes & More ----------------------------------------
                        flight.type = 'CI';
                        tooltiptData = Vue.prototype.$buildEventNote(flight);
                        note += tooltiptData.note;


                        // >>> Times -----------------------------------------------
                        utcDepartureTime = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).toDate();
                        utcArrivalTime = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).toDate();

                        year_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('YYYY'); // New: #87
                        month_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('MM');
                        day_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('DD');
                        hours_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('HH');
                        minutes_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('mm');

                        year_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('YYYY');
                        month_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('MM');
                        day_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('DD');
                        hours_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('HH');
                        minutes_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('mm');

                        utcDepartureTime.setYear(year_departure_time); // New: #87
                        utcDepartureTime.setMonth(month_departure_time - 1);
                        utcDepartureTime.setDate(day_departure_time);
                        utcDepartureTime.setHours(hours_departure_time);
                        utcDepartureTime.setMinutes(minutes_departure_time - 1); // little Correction

                        utcArrivalTime.setYear(year_arrival_time);
                        utcArrivalTime.setMonth(month_arrival_time - 1);
                        utcArrivalTime.setDate(day_arrival_time);
                        utcArrivalTime.setHours(hours_arrival_time);
                        utcArrivalTime.setMinutes(minutes_arrival_time - 1); // little Correction


                        // >>> Push ------------------------------------------------
                        if (String(datebefore) !== String(utcDepartureTime) || (String(datebefore) === String(utcDepartureTime) && resourceIdBefore !== resourceId)) {
                            t2 = {
                                originalId: flight.id, // Note: #67
                                resourceId: resourceId,
                                startDate: utcDepartureTime,
                                endDate: utcArrivalTime,
                                name: 'CHECKIN', // for Tooltip Header
                                note: note,
                                nameEvent: '',
                                crew: '',
                                // >>> ------------------
                                iconCls: getColors.iconCls,
                                style: null,
                                eventColor: getColors.eventColor,
                                eventStyle: getColors.eventStyle,
                                cls: getColors.cls,
                                // >>> ------------------
                                requested: null,
                                activated: null,
                                remainingDayOff: null,
                                // >>> ------------------
                                idApt: null, // originally: AVAILABLE
                                aptCode: null,
                                // >>> ------------------
                                certificate: null, // originally: SICKNESS
                                fit: null,
                                sickOnTour: null,
                                sickChild: null,
                                // >>> ------------------ RESERVE
                                sleepFrom: null,
                                sleepTo: null,
                                // >>> ------------------ MEETING
                                dutyComment: null,
                                flightComment: null,
                                // >>> ------------------ STANDBY
                                activationDate: null,
                                // >>> ------------------ HOTEL
                                hotelObject: null,
                                // >>> ------------------ PRO
                                proObject: null,
                                // >>> ------------------ TRAINING
                                trainingObject: null,
                            };
                            datebefore = utcDepartureTime;
                            resourceIdBefore = resourceId;
                            tmpArrayCiCos.push(t2);
                        }
                        // <<< Checkin ----------------------------------





                        // >>> Checkout ---------------------------------
                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';


                        // >>> Notes & More ----------------------------------------
                        flight.type = 'CO';
                        tooltiptData = Vue.prototype.$buildEventNote(flight);
                        note += tooltiptData.note;


                        // >>> Times -----------------------------------------------
                        utcDepartureTime = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).toDate();
                        utcArrivalTime = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).toDate();

                        year_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('YYYY'); // New: #287
                        month_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('MM');
                        day_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('DD');
                        hours_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('HH');
                        minutes_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('mm');

                        year_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('YYYY');
                        month_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('MM');
                        day_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('DD');
                        hours_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('HH');
                        minutes_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('mm');

                        utcDepartureTime.setYear(year_departure_time); // New: #287
                        utcDepartureTime.setMonth(month_departure_time - 1);
                        utcDepartureTime.setDate(day_departure_time);
                        utcDepartureTime.setHours(hours_departure_time);
                        utcDepartureTime.setMinutes(minutes_departure_time);

                        utcArrivalTime.setYear(year_arrival_time);
                        utcArrivalTime.setMonth(month_arrival_time - 1);
                        utcArrivalTime.setDate(day_arrival_time);
                        utcArrivalTime.setHours(hours_arrival_time);
                        utcArrivalTime.setMinutes(minutes_arrival_time);


                        // >>> Push ------------------------------------------------
                        if (String(datebefore2) !== String(utcDepartureTime) || (String(datebefore2) === String(utcDepartureTime) && resourceIdBefore2 !== resourceId)) {
                            t3 = {
                                originalId: flight.id, // Note: #67
                                resourceId: resourceId,
                                startDate: utcDepartureTime,
                                endDate: utcArrivalTime,
                                name: 'CHECKOUT', // for Tooltip Header
                                note: note,
                                nameEvent: '',
                                crew: '',
                                // >>> ------------------
                                iconCls: getColors.iconCls,
                                style: null,
                                eventColor: getColors.eventColor,
                                eventStyle: getColors.eventStyle,
                                cls: getColors.cls,
                                // >>> ------------------
                                requested: null,
                                activated: null,
                                remainingDayOff: null,
                                // >>> ------------------
                                idApt: null, // originally: AVAILABLE
                                aptCode: null,
                                // >>> ------------------
                                certificate: null, // originally: SICKNESS
                                fit: null,
                                sickOnTour: null,
                                sickChild: null,
                                // >>> ------------------ RESERVE
                                sleepFrom: null,
                                sleepTo: null,
                                // >>> ------------------ MEETING
                                dutyComment: null,
                                flightComment: null,
                                // >>> ------------------ STANDBY
                                activationDate: null,
                                // >>> ------------------ HOTEL
                                hotelObject: null,
                                // >>> ------------------ PRO
                                proObject: null,
                                // >>> ------------------ TRAINING
                                trainingObject: null,
                            };
                            datebefore2 = utcDepartureTime;
                            resourceIdBefore2 = resourceId;
                            tmpArrayCiCos.push(t3);
                        }
                        // <<< Checkout ---------------------------------
                    });
                }
                // <<< ----------------------------------------

                // >>> 'proceedings' -------------------------- // OK, New: via ... buildUTCTime
                if (item.proceedings && item.proceedings.length) {
                    item.proceedings.forEach(proceeding => {
                        const getColors = eventColors.find(colors => colors.duty === 'PROCEEDING');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';

                        // >>> Notes & More ----------------------------------------
                        proceeding.typeOfProceeding = proceeding.type; // special: cause 'type' exits already in pro
                        proceeding.type = 'PRO';
                        tooltiptData = Vue.prototype.$buildEventNote(proceeding);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Push ------------------------------------------------
                        t = {
                            originalId: proceeding.id, // Note: #67
                            resourceId: resourceId,
                            startDate: Vue.prototype.$buildUTCTime(proceeding.proceedingStart),
                            endDate: Vue.prototype.$buildUTCTime(proceeding.proceedingEnd),
                            name: 'PROCEEDING',
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: proceeding.status === 'PENDING' ? 'border: 1px solid red !important;' : null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            flightComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: proceeding,
                            // >>> ------------------ TRAINING
                            trainingObject: null,
                        };
                        tmpArrayProceedings.push(t);
                    });
                }
                // <<< ----------------------------------------

                // >>> 'hotels' ------------------------------- // OK, New: via ... buildUTCTime
                if (item.hotels && item.hotels.length) {
                    item.hotels.forEach(hotel => {
                        const getColors = eventColors.find(colors => colors.duty === 'HOTEL');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';

                        // >>> Notes & More ----------------------------------------
                        hotel.type = 'HOTEL';
                        tooltiptData = Vue.prototype.$buildEventNote(hotel);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Push ------------------------------------------------
                        t = {
                            originalId : hotel.id,  // Note: #67
                            resourceId: resourceId,
                            startDate: Vue.prototype.$buildUTCTime(hotel.checkinDate),
                            endDate: Vue.prototype.$buildUTCTime(hotel.checkoutDate),
                            name: 'HOTEL',
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            flightComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: hotel,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: null,
                        };
                        tmpArrayHotels.push(t);
                    });
                }
                // <<< ----------------------------------------

                // >>> 'trainings' ---------------------------- // OK, New: via ... buildUTCTime
                if (item.trainings && item.trainings.length) {
                    item.trainings.forEach(training => {
                        const getColors = eventColors.find(colors => colors.duty === 'TRAINING');

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';

                        // >>> Notes & More ----------------------------------------
                        training.type = 'TRAINING';
                        tooltiptData = Vue.prototype.$buildEventNote(training);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Push ------------------------------------------------
                        t = {
                            originalId : training.id,  // Note: #67
                            resourceId: resourceId,
                            startDate: Vue.prototype.$buildUTCTime(training.nextCheckStartDate),
                            endDate: Vue.prototype.$buildUTCTime(training.nextCheckEndDate),
                            name: 'TRAINING',
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: training.activated === true ? 'border: 1px solid red !important;' : null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            flightComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: training,
                        };
                        tmpArrayTrainings.push(t);
                    });
                }
                // <<< ----------------------------------------

                // >>> 'breaks' ------------------------------- // OK
                if (item.breaks && item.breaks.length) {
                    item.breaks.forEach(mybreak => {
                        const getColors = eventColors.find(colors => colors.duty === mybreak.type);

                        note = ''; // reset
                        nameEvent = '';
                        tooltiptData = '';
                        style = null;
                        utcDepartureTimeActivation = null;

                        // >>> Notes & More ----------------------------------------
                        tooltiptData = Vue.prototype.$buildEventNote(mybreak);
                        note += tooltiptData.note;
                        nameEvent += tooltiptData.nameEvent;

                        // >>> Times -----------------------------------------------
                        if (mybreak.type !== 'SICKNESS' && mybreak.type !== 'DAYOFF' && mybreak.type !== 'FREEDAY' && mybreak.type !== 'VACATION' && mybreak.type !== 'UNABLEFLIGHT' && mybreak.type !== 'AVAILABLE') {
                            utcDepartureTime = Vue.prototype.$buildUTCTime(mybreak.from);
                            utcArrivalTime = Vue.prototype.$buildUTCTime(mybreak.to);
                        }

                        if (mybreak.type === 'SICKNESS' || mybreak.type === 'DAYOFF' || mybreak.type === 'FREEDAY' || mybreak.type === 'VACATION' || mybreak.type === 'UNABLEFLIGHT' || mybreak.type === 'AVAILABLE') {
                            utcDepartureTime = moment.utc(mybreak.from, moment.ISO_8601).toDate();
                            utcArrivalTime = moment.utc(mybreak.to, moment.ISO_8601).toDate();

                            utcDepartureTime.setHours(0);
                            utcDepartureTime.setMinutes(0);
                            utcArrivalTime.setHours(23);
                            utcArrivalTime.setMinutes(59);
                        }



                        // >>> Others ----------------------------------------------
                        if (mybreak.type === 'DAYOFF') {
                            // style = mybreak.activated === true ? 'border-color: #27ca37; color: #27ca37;' : null;
                            style = mybreak.activated === true ? 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px)' : null;

                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'FREEDAY') {
                            // style = mybreak.activated === true ? 'border-color: #27ca37; color: #27ca37;' : null;
                            style = mybreak.activated === true ? 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px)' : null;

                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'RES') {
                            utcDepartureTimeSleep = Vue.prototype.$buildUTCTime(mybreak.sleepFrom);
                            utcArrivalTimeSleep = Vue.prototype.$buildUTCTime(mybreak.sleepTo);
                        }

                        if (mybreak.type === 'STANDBY') {
                            if (mybreak.activationDate !== null) {
                                utcDepartureTimeActivation = Vue.prototype.$buildUTCTime(mybreak.activationDate);
                                style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                            };
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'AVAILABLE') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'OFFICE') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'VACATION') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'RES') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }

                        if (mybreak.type === 'SICKNESS') {
                            if (mybreak.dutyComment !== null) {
                                if (style !== null) {
                                    style = style + ' border-right: 3px dotted #000;';
                                } else {
                                    style = ' border-right: 3px dotted #000;';
                                }
                            }
                        }


                        // >>> Push ------------------------------------------------
                        t = {
                            originalId : mybreak.id, // Note: #67
                            resourceId: resourceId,
                            startDate: utcDepartureTime,
                            endDate: utcArrivalTime,
                            name: getColors.breakName.toUpperCase(),
                            nameEvent: nameEvent,
                            note: note,
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: style,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: mybreak.requested,
                            activated: mybreak.activated,
                            remainingDayOff: mybreak.remainingDayOff,
                            // >>> ------------------ AVAILABLE, STANDBY
                            idApt: mybreak.idApt,
                            aptCode: mybreak.aptCode,
                            // >>> ------------------ SICKNESS
                            certificate: mybreak.certificate,
                            fit: mybreak.fit,
                            sickOnTour: mybreak.sickOnTour,
                            sickChild: mybreak.sickChild,
                            // >>> ------------------ RESERVE
                            sleepFrom: utcDepartureTimeSleep,
                            sleepTo: utcArrivalTimeSleep,
                            // >>> ------------------ MEETING
                            dutyComment: mybreak.dutyComment,
                            flightComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: utcDepartureTimeActivation,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: null
                        };
                        tmpArrayBreaks.push(t);

                    });
                }
                // <<< ----------------------------------------

            });


            recs.push(...tmpArrayFlights);
            recs.push(...tmpArrayCiCos);
            recs.push(...tmpArrayProceedings);
            recs.push(...tmpArrayHotels);
            recs.push(...tmpArrayTrainings);
            recs.push(...tmpArrayBreaks);


            return recs;

        }; // eof build_MultipleDuties()


        /***********************************************************************
        * Global: 'build_EventsInFlights'
        *
        * Desc:
        * Note:
        *
        * @return {Object} payload (Calls Objects to build Stores Records)
        */
        Vue.prototype.$build_EventsInFlights = function (payload) {

            let tmp_Events = [];


            // >>> Legs => Build Events -----------------------
            payload.forEach((leg) => {

                let flight_cls = "",
                    style = "";


                // >>> ---------------------------------------- Validation Colors
                if (leg.hasCrew === false) {
                    flight_cls = 'scheduler-event flight_HasNoCrew';            // 'red'
                    style = "";
                }

                if (leg.hasCrew === true) {
                    if (leg.validCrew !== true || leg.validCrewNumber !== true) {
                        flight_cls = 'scheduler-event flight_HasInvalidCrew';   // 'yellow'
                    }

                    if (leg.validCrew === true && leg.validCrewNumber === true) {
                        flight_cls = 'scheduler-event flight_HasCrew';          // 'green'
                    }

                    if (leg.validateExtends.validated === false) {              // border
                        style = "border-left: solid 4px red;";
                    }
                    if (leg.validateExtends.validated === true) {
                        style = "";
                    }
                }
                // <<< ----------------------------------------


                // >>> ----------------------------------------
                tmp_Events.push(
                    {
                        "id": leg.idFlight,
                        "resourceId": leg.idAircraft,
                        "name": leg.flightNo,
                        "startDate": Vue.prototype.$buildUTCTime(leg.departureTime),
                        "endDate": Vue.prototype.$buildUTCTime(leg.arrivalTime),
                        "durationUnit": "h",
                        "cls": flight_cls,
                        "iconCls": '', // leg.overnight === true ? 'v-icon mdi mdi-weather-night' : 'v-icon mdi mdi-airplane',
                        "isParent": true,
                        "style": style, // New
                        // "eventColor"    : "#afb3eb"
                        // "eventType"    : "",
                        "legInfo": leg,
                    },
                );
            });


            // state.flights_Events = tmp_Events;
            return tmp_Events;

        }; // eof build_EventsInFlights()


        /***********************************************************************
        * Global: vp_m()
        *
        * Desc: Mask Viewport.
        * Note: Loader Config here.
        *
        */
        Vue.prototype.$vp_m = function () {

            Vue.loader = this.$loading.show({
                // container: this.$refs.loadingContainer, // ?
                canCancel: false, // default false
                color: '#9F4378',
                loader: 'spinner',
                width: 64,
                height: 64,
                backgroundColor: '#ffffff',
                opacity: 0.5
            });

        }; // eo function vp_m()


        /***********************************************************************
        * Global: vp_m()
        *
        * Desc: Unmask Viewport.
        * Note:
        *
        */
        Vue.prototype.$vp_um = function () {

            Vue.loader.hide();

        }; // eo function vp_um()


		/***********************************************************************
        * Global: trnsl_error_message()
        *
        * Desc:
        * Note: Very incomplete!!!
        *
        * @param {String} m (Message to log)
        */
        Vue.prototype.$trnsl_error_message = function(m) {

			let nsa = '', // new string a
				nsb = '', // new string b
				splittedMessage = [],
				trsnltd = [],
				currentLocale = 'de',
				localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')), // catch
				errors = [
					{ key: '85037', de: 'Ungültige Anzahl von Flügen.', en: 'Invalid number of flights.' }, // 'modify2'
				];


			// Language in localStorage?
			if (localStorageLanguage !== null) {
				currentLocale = localStorageLanguage.value;
			}

			nsa = m.substring(1); // del 1st
			nsb = nsa.substr(0, nsa.length - 1); // del last
			splittedMessage = nsb.split(']['); // split
			trsnltd = errors.find((item) => item.key === splittedMessage[0]); // find


			return trsnltd[currentLocale];

		}; // eo function trnsl_error_message()


		/***********************************************************************
        * Global: checkSingleOccurrence()
        *
        * Desc: Checks if thre is a Checker "C", instructor "I" or Trainiee "T"
        * Desc: on the given 'crew' String.
        * Note:
        *
        * @param {String} inputString (String to check) (crew's String)
        * @param {String} character (Character to check)
        */
        Vue.prototype.$checkSingleOccurrence = function(inputString, character) {

            let segments = inputString.split(',');
            let count = 0;

            for (let segment of segments) {
                let words = segment.split(' ');
                for (let word of words) {
                    if (word.trim() === character) count++;
                }
            }

            return count === 1;

        }, // eo function checkSingleOccurrence()


        /***********************************************************************
        * Global: toc()
        *
        * Desc: Application Infos while Debugging.
        * Note: Now via config.js.
        *
        * @param {String} m (Message to log)
        */
        Vue.prototype.$toc = function (m) {

            const rm = 'PROD'; // CONF_ENVIRONMENT;


            if (rm === 'DEV') {
                console.log(m);
            }

        }; // eo function toc()

    } // eo install{}
};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default SundAir2021Plugin;


